import "../SMSSolutions/SMSSolutions.css";
import {
  FaCheckCircle,
  FaBolt,
  FaEye,
  FaBullhorn,
  FaPlug,
  FaHeartbeat,
  FaUniversity,
  FaShoppingCart,
  FaGraduationCap,
  FaBuilding,
  FaPlane,
} from "react-icons/fa";
import centerImage from "../../pages/IVRSolutions/assets/ss.png";
import flowSmsImage from "./assets/flow-sms.png";
const SMSSolutions = () => {
  return (
    <>
      <div className="services-bannerff">
        <div className="overlayff"></div>
        <div className="contentff">
          <div className="lineff"></div>
          <div>
            <h1>SMS</h1>
            <p>
              Nowadays’s aggressive digital landscape, companies need fast,
              direct, and effective communique channels to <br /> interact with
              clients and drive conversions. One of the most effective tools
              available is a <b className="bold">bulk sms service</b>, which
              permits agencies <br /> to right away connect with their audience
              through cellular messaging.{" "}
            </p>
            <p>
              <span className="homeff">Home</span> → Service → Short Message
              Service
            </p>
          </div>
        </div>
      </div>
      <section className="ivr-section">
        <div className="ivr-container">
          <section className="about-sectionvv">
            <div className="about-containervv">
              <div className="about-contentvv">
                <span className="about-tagvv">Bulk SMS Service</span>

                <h1>What is Bulk SMS Service?</h1>

                <p className="about-descvv">
                  A bulk sms provider permits agencies to send massive volumes
                  of messages to customers in a single click. These messages may
                  be promotional, transactional, or informational, depending on
                  enterprise necessities. Unlike emails or social media ads, SMS
                  messages are introduced immediately to customers’ cell
                  inboxes, making sure higher visibility and engagement. With
                  the assist of a dependable <b className="bold">bulk sms service provider</b>,
                  groups can attain heaps of customers instantly without delays.
                </p>
                <div className="about-featuresvv">
                  <div className="feature-rightvv">
                    <p>
                      <FaCheckCircle /> Navigate menus the usage of voice or
                      keypad
                    </p>
                    <p>
                      <FaCheckCircle /> Access records immediately
                    </p>
                    <p>
                      <FaCheckCircle /> Connect to the proper department
                      quickly.
                    </p>
                  </div>
                </div>
                <p>
                  A superior IVR phone system integrates with CRM and databases
                  to provide personalized consumer reports. This makes your
                  interactive voice response carrier smarter and extra green.
                </p>
                <br />
              </div>
            </div>
            <section className="services-bb">
              <div className="container-bb">
                <h5 className="subheading-bb">SMS Solution Flow</h5>
                <h2 className="heading-bb">SMS Solution Flow </h2>

                <div style={{ marginTop: "24px" }}>
                  <img
                    src={flowSmsImage}
                    alt="SMS solution flow diagram"
                    style={{ width: "100%", maxWidth: "1200px", height: "auto" }}
                  />
                </div>
              </div>
            </section>
            <section className="why-section">
              <div className="why-left">
                <span className="tags">Prefer</span>

                <h1>Why Businesses Prefer Bulk SMS Service</h1>
                <p>
                  There are numerous reasons why corporations across industries
                  depend on a bulk sms carrier:
                </p>
              </div>
              <br />
              <div className="why-container">
                <div className="why-right">
                  <div className="card">
                    <h3><FaBolt className="why-icon" /> Instant Communication</h3>
                    <p>
                      Messages are delivered inside seconds, making it perfect
                      for time-sensitive updates and indicators.
                    </p>
                  </div>
                  <div className="card">
                    <h3><FaEye className="why-icon" /> High Open Rates</h3>
                    <p>
                      SMS has an open fee of over ninety%, making sure your
                      message receives observed.
                    </p>
                  </div>
                  <div className="card">
                    <h3><FaBullhorn className="why-icon" /> Cost-Effective Marketing</h3>
                    <p>
                      A <b className="bold">bulk sms service</b> issuer gives low-cost pricing
                      compared to conventional marketing methods.
                    </p>
                  </div>
                  <div className="card">
                    <h3><FaPlug className="why-icon" /> Easy Integration</h3>
                    <p>
                      With our <b className="bold">sms gateway api</b>, you may combine messaging
                      directly into your machine, CRM, or cell app.
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="why-sectionz">
              <h2>Key Features of Our Bulk SMS Service</h2>

              <p className="why-descz">
                Our platform is designed to provide a continuing and effective
                messaging enjoy:
              </p>

              <div className="why-containerz">
                <div className="why-gridz">
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle />
                      High-pace SMS delivery across India
                    </p>
                    <p>
                      <FaCheckCircle /> Real-time delivery reviews
                    </p>
                    <p>
                      <FaCheckCircle /> User-friendly dashboard for marketing
                      campaign management
                    </p>
                  </div>
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle /> Support for Unicode SMS (nearby
                      languages)
                    </p>
                    <p>
                      <FaCheckCircle /> Advanced sms gateway api for automation
                    </p>
                    <p>
                      <FaCheckCircle /> Custom sender ID options
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="industriesss">
              <h2>Industries We Serve</h2>
              <p>
                Our bulk sms provider is broadly used across more than one
                industry:
              </p>
              <br />
              <div className="industries-containerss">
                <div className="industries-rightss">
                  <div className="cardss"><FaHeartbeat className="industry-icon" /> Healthcare</div>
                  <div className="cardss"><FaUniversity className="industry-icon" /> Banking & Finance</div>
                  <div className="cardss"><FaShoppingCart className="industry-icon" /> E-commerce</div>
                  <div className="cardss"><FaGraduationCap className="industry-icon" /> Education</div>
                  <div className="cardss"><FaBuilding className="industry-icon" /> Real Estate</div>
                  <div className="cardss"><FaPlane className="industry-icon" /> Travel & Hospitality</div>
                </div>
              </div>
            </section>
            <section className="whyss">
              <p className="subtitless">WHY CHOOSE US</p>
              <h2 className="titless">Why Choose Us?</h2>
              <p>
                We stand out as a trusted bulk sms provider provider because of
                our dedication to quality and innovation.
              </p>

              <div className="why-containerss">
                <div className="center-imagess">
                  <img src={centerImage} alt="transport" />
                </div>
                <div className="left-cardsss">
                  <div className="cardsss left-card card1">
                    <span> Fast and dependable SMS transport</span>
                  </div>
                  <div className="cardsss left-card card2">
                    <span>Advanced sms gateway api integration</span>
                  </div>
                </div>
                <div className="right-cards">
                  <div className="cardsss left-card card3">
                    <span>Dedicated aid crew</span>
                  </div>
                  <div className="cardsss right-card card4">
                    <span>Easy-to-use dashboard</span>
                  </div>
                </div>
              </div>
            </section>
            <br />
            <br />
            <section className="why-sectionz">
              <h2>Benefits of Choosing Our Bulk SMS Provider in India</h2>

              <p className="why-descz">
                As a main <b className="bold">Bulk SMS Provider India</b>, we offer unmatched
                provider exceptional and overall performance.
              </p>

              <div className="why-containerz">
                <div className="why-gridz">
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle />
                      Reliable Delivery
                    </p>
                    <p>
                      <FaCheckCircle /> Scalable Platform
                    </p>
                    <p>
                      <FaCheckCircle /> 24/7 Support
                    </p>
                  </div>
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle /> Affordable Pricing
                    </p>
                    <p>
                      <FaCheckCircle /> Secure Messaging
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default SMSSolutions;
